import { useState } from 'react';
import { useTranslation } from "react-i18next";
import Progress from '../../../common/progress';
import { IsRightToLeftTheme } from '../../../theme/themehelper';
import MatchInformation from '../../../slimcoupon/matchinformation';
import { Box, Grid, SxProps, Theme } from '@mui/material';
import { FixtureDetail } from '../../../models/fixturedetail';
import { Fixture } from '../../../models/fixture';
import MatchStatistics from '../../../slimcoupon/matchstatistics';
import LeagueTable from '../../../slimcoupon/leaguetable';
import ScoreBoard from '../scoreboard';
import { Round } from '../../../models/round';
import MatchEvents from './matchevents';

/* ------------------------------------------------------------------ */
/*  Sx styles                                                         */
/* ------------------------------------------------------------------ */

const wrapperSx: SxProps<Theme> = {
  backgroundColor: "var(--background_1)",
  color: "var(--text-black-dark-background)",
};

const menuSx: SxProps<Theme> = {
  display: "flex",
  flexDirection: "var(--flex-direction)" as any,
  width: "90%",
  justifyContent: "center",
  alignItems: "center",
  margin: "0 auto",
  fontSize: "13px",
};

const menuItemSx: SxProps<Theme> = {
  textAlign: "center",
  padding: "12px 10px",
  cursor: "pointer",
};

const componentGridSx: SxProps<Theme> = {
  overflowY: "auto",
  backgroundColor: "var(--fixtureinformation-background)",
};

function SelectedFixture({ fixtureDetail, isAfterGameStart, roundFixture, theme, round }:
  { fixtureDetail: FixtureDetail, isAfterGameStart: boolean, roundFixture: Fixture, theme: string, round: Round }) {

  const [menuIndex, setMenuIndex] = useState(isAfterGameStart ? 3 : 0);
  const { t } = useTranslation();

  if(round === undefined){
    return <></>;
  }

  const isHockey = round.name.indexOf('Hockey') > -1;

  let isRightToLeft = IsRightToLeftTheme(theme);

  if (!roundFixture) {
    return (
      <Box sx={wrapperSx}>
        <Box sx={{ height: "100%" }}>
          <Progress />
        </Box>
      </Box>
    );
  }

  let ComponentToRender;

  switch (menuIndex) {
    case 0:
      ComponentToRender = MatchInformation;
      break;
    case 1:
      ComponentToRender = MatchStatistics;
      break;
    case 2:
      ComponentToRender = LeagueTable;
      break;
    case 3:
      ComponentToRender = MatchEvents;
      break;
    default:
      ComponentToRender = MatchInformation;
      break;
  }

  return (
    <Box sx={wrapperSx}>
      <ScoreBoard fixtureDetail={fixtureDetail} roundFixture={roundFixture} theme={theme} round={round} />
      <Box>
        <Box sx={menuSx}>
          <Box sx={menuItemSx} onClick={() => setMenuIndex(0)}>
            <Box component="span" sx={menuIndex === 0 ? { textDecoration: "underline" } : undefined}>{t('game_info')}</Box>
          </Box>

          {!isHockey &&
            <Box sx={menuItemSx} onClick={() => setMenuIndex(1)}>
              <Box component="span" sx={menuIndex === 1 ? { textDecoration: "underline" } : undefined}>{t('statistics')}</Box>
            </Box>
          }

          {!isHockey &&
            <Box sx={menuItemSx} onClick={() => setMenuIndex(2)}>
              <Box component="span" sx={menuIndex === 2 ? { textDecoration: "underline" } : undefined}>{t('table')}</Box>
            </Box>
          }

          {!isHockey &&
            <Box sx={menuItemSx} onClick={() => setMenuIndex(3)}>
              <Box component="span" sx={menuIndex === 3 ? { textDecoration: "underline" } : undefined}>{t('game_summary')}</Box>
            </Box>
          }

        </Box>
      </Box>
      {fixtureDetail &&
        <Grid container direction='column' alignItems='center' sx={componentGridSx}>
          <ComponentToRender fixture={roundFixture} fixtureDetails={fixtureDetail} isRightToLeft={isRightToLeft} isHockey={isHockey}/>
        </Grid>
      }
    </Box>
  );
}

export default SelectedFixture;
